import Vue from 'vue';
import Vuex from 'vuex';

import user from './user.module';
import global from './global.module';
import flow from './flow.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    global,
    flow,
  },
});
